import { useRef, useCallback, useEffect } from 'react'
import { OmoteAvatar, preloadAvatar, type OmoteAvatarRef, type AvatarReadyEvent, type GazeConfig } from '@omote/r3f'
import { createLogger } from '@omote/core/logging'
import { useAvatarStore } from '../hooks/useAvatarStore'
import { useAvatarPose } from '../scene'

const logger = createLogger('Avatar3D')
const DEFAULT_AVATAR_URL = '/models/avatar.glb'
const GAZE_CONFIG: GazeConfig = { enabled: true, target: 'camera', yawInfluence: 0.35, pitchInfluence: 0.25, smoothing: 4 }

interface Avatar3DProps {
  scale?: number
  avatarUrl?: string
}

export default function Avatar3D({ scale = 1, avatarUrl = DEFAULT_AVATAR_URL }: Avatar3DProps) {
  const avatarRef = useRef<OmoteAvatarRef>(null)
  const { position, rotation } = useAvatarPose()

  const handleReady = useCallback((event: AvatarReadyEvent) => {
    logger.info('Avatar loaded', {
      animations: event.animationControls.availableAnimations,
      morphTargets: Object.keys(event.morphTargetDictionary || {}).length,
    })
    useAvatarStore.getState().setAvatarRef(avatarRef.current)
  }, [])

  useEffect(() => {
    return () => { useAvatarStore.getState().setAvatarRef(null) }
  }, [])

  return (
    <OmoteAvatar
      ref={avatarRef}
      src={avatarUrl}
      gaze={GAZE_CONFIG}
      avatarScale={scale}
      sceneRotationY={0.5236}
      position={position as [number, number, number]}
      rotation={[0, rotation, 0]}
      onReady={handleReady}
    />
  )
}

preloadAvatar(DEFAULT_AVATAR_URL)
